import qs from "query-string";
import { mapCatalogTrackObject } from "./map";
import { http } from "../client";
export var getCatalogTracks = function (_a) {
    var search = _a.search, genres = _a.genres, limit = _a.limit, offset = _a.offset, sortBy = _a.sortBy, orderBy = _a.orderBy;
    return http.api
        .get("tracks/search", {
        params: {
            any: search !== null && search !== void 0 ? search : "",
            genres: genres !== null && genres !== void 0 ? genres : "",
            take: limit,
            skip: offset,
            sort_colmn: sortBy,
            sort_order: orderBy,
        },
        paramsSerializer: function (params) {
            return qs.stringify(params, { arrayFormat: "comma", skipEmptyString: true });
        },
    })
        .then(function (response) { return response.data.data; })
        .then(function (_a) {
        var total = _a.total, items = _a.items;
        return ({
            total: total,
            tracks: items.map(mapCatalogTrackObject),
        });
    });
};
export var getRawTracks = function (_a) {
    var search = _a.search, genres = _a.genres, limit = _a.limit, offset = _a.offset, sort_column = _a.sort_column, sort_order = _a.sort_order;
    return http.api
        .get("tracks/search", {
        params: {
            any: search !== null && search !== void 0 ? search : "",
            genres: genres !== null && genres !== void 0 ? genres : "",
            take: limit,
            skip: offset,
            sort_column: sort_column,
            sort_order: sort_order,
        },
        paramsSerializer: function (params) {
            return qs.stringify(params, { arrayFormat: "comma", skipEmptyString: true });
        },
    })
        .then(function (response) { return response.data.data; })
        .then(function (_a) {
        var total = _a.total, items = _a.items;
        return ({
            total: total,
            tracks: items //.map(mapRawTrackObject),
        });
    });
};
